import React from 'react';
import PropTypes from 'prop-types';
import CloseButton from '../../common/CloseButton/CloseButton';
import '../../common/CommonText.css';
import './RenewCount.css';


const RenewCountPopup = ({ isOpen, onClose, title, date, rows }) => {
  if (!isOpen) return null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  

  return (
    <div className="popup-overlay">
      <div className="popup archive-popup popup2 renew-count-popup">
        <CloseButton onClick={onClose} />
        <div className='renew-count-container'>
          <span className='common-text black fts-17 ftw-5'>{title}</span>
          <span className='common-text red fts-13 ftw-5'>New Renewal Date: {formatDate(date)}</span>

        </div>
        <div className='renew-count-table-container'>
          <table className='renew-table'>
            <thead className='renew-table-head'>
              <tr className='renew-table-thead-tr'>
                <th className='common-text black fts-15 ftw-5'>Plan</th>
                <th className='common-text black fts-15 ftw-5'>Start & End Date</th>
                <th className='common-text black fts-15 ftw-5'>User Limit</th>
                <th className='common-text black fts-15 ftw-5'>Status</th>
              </tr>
            </thead>
            <tbody className='renew-table-tbody'>
              {rows.map((row, index) => (
                <tr key={index} className='renew-table-tbody-tr'>
                  <td className='common-text black fts-15'>{row.plan}</td>
                  {/* <td className='common-text black fts-15'>{row.start_date} to {row.end_date}</td> */}
                  <td className='common-text black fts-15'>
                    {formatDate(row.start_date)} to {formatDate(row.end_date)}
                  </td>

                  <td className='common-text black fts-15'><span className='green'>{row.active_users}</span>/{row.user_limit}</td>
                  <td className={row.status.toLowerCase() === 'active' ? 'green common-text fts-15' : 'common-text fts-15'}>
                    {row.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

RenewCountPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    plan: PropTypes.string,
    start_date: PropTypes.string,
    end_date: PropTypes.string,
    user_limit: PropTypes.string,
    status: PropTypes.string,
  })).isRequired,
};

export default RenewCountPopup;